import request from '@/router/axios'
import env from '@/config/env'

// 摆渡订单统计接口
export const ferryOrderCount = (params) => {
  return request({
    url: env.ferryUrl + '/close/station/ferry-order/count',
    method: 'POST',
    data: params
  })
}
// 获取昆明站点信息
export const stationInfo = (params) => {
  return request({
    url: env.ferryUrl + '/close/station/station-info-kunming',
    method: 'GET',
    params
  })
}
// 分页接口
export const stationPage = (params) => {
  return request({
    url: env.ferryUrl + '/close/station/page',
    method: 'POST',
    data: params
  })
}
// 删除接口
export const stationDelete = (id) => {
  return request({
    url: env.ferryUrl + '/close/station/del/' + id,
    method: 'DELETE'
  })
}
// 保存接口
export const stationSave = (params) => {
  return request({
    url: env.ferryUrl + '/close/station/save',
    method: 'POST',
    data: params
  })
}
